import { z } from "zod";

/** The workspace settings card. `name` was checked in the save handler. */
export const workspaceFormSchema = z.object({
  name: z.string().trim().min(1, "Укажите название").max(120),
  domainId: z.string(),
  goalPreset: z.string(),
  /** IANA zone the workspace's reports count days in. */
  timezone: z.string().trim().min(1, "Выберите часовой пояс"),
});

export type WorkspaceFormValues = z.infer<typeof workspaceFormSchema>;
